import styled from 'styled-components';

const BoxHeaderWrapper = styled.div`
  border-bottom: ${props => `1px solid ${props.theme.gray300}`};
`;

export default function BoxHeader({ children, className }) {
  return <BoxHeaderWrapper className={className}>{children}</BoxHeaderWrapper>;
}
